var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('omint-page',[_c('Header',{attrs:{"name":"Termo de Aceite","titleLabel":"Termo de Aceite"}}),_c('omint-slider',[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }